// extracted by mini-css-extract-plugin
export default {"inquiryModalBody":"style_inquiryModalBody__HEhY9","description":"style_description__POkoX","field":"style_field__QKGkO","label":"style_label__8v5yw"};